<template>
    <div class="header-bar w-full h-full bg-base flex justify-between px-32 py-16">
        <div class="font-black text-20 flex gap-8 items-center basis-1/4">
            <WFIcon class="w-26" name="clock"></WFIcon><WFClock class="mt-6 mr-8"></WFClock> <WFTranslate class="mt-6" k="opening-hours"></WFTranslate>
        </div>
        <WFBuildingLogo class="grow shrink-1"/>
        <div class="header-bottom w-full flex text-primary-content justify-end  basis-1/4">
            <WFLanguagesMenu class="rounded-lg gap-4 font-medium" :showTitle="true" :showFlag="false" order="order" labelType="code"></WFLanguagesMenu>
        </div>
    </div>
</template>

<script>
import { WFBuildingLogo, WFLanguagesMenu } from '@3dwayfinder/wayfinder-vue-components'

export default {
    name: 'THHeader',
    components: {
		WFBuildingLogo,
        WFLanguagesMenu
    },
}
</script>

<style lang="postcss">
    .header-bar {
        border-bottom: 0.2rem solid var(--th-border);
    }

    .wf-building-logo {
        height: 100%;
        min-width: 16rem;
    }
    .header-dt {
        text-align: right;
        flex-shrink: 0;
    }

    .wf-date {
        font-size: 2.4rem;
        font-weight: 500;
    }

    .wf-floors-menu .wf-list {
        display: flex;
        color: var(--th-primary-content);

        .wf-active {
            color: var(--th-active);
            background-color: var(--th-active-content);
        }
    }
</style>